import React, {useEffect, useState} from "react";
import styled from "styled-components/macro";

import Helmet from "react-helmet";

import {
    Grid,
    Divider as MuiDivider,
    Typography,
} from "@material-ui/core";

import { spacing } from "@material-ui/system";
import {LOCAL_STORAGE_KEYS, ORG_TYPE} from "../../utils/constants";
import ListProfilesActivations from "./components/ListProfilesActivations";
import {useLocation} from "react-router-dom";
import {GET_APP_LOCALIZE_TEXT} from "../../utils/dq_lc_service/lc_service";


const Divider = styled(MuiDivider)(spacing);

const ResponsiveGridItem = styled(Grid)`
    max-width: 100%;
    overflow: hidden;
    
    @media (max-width: 768px) {
        max-width: 95vw;
    }
    
    @media (max-width: 1024px) and (min-width: 769px) {
        max-width: 73vw;
    }
`;


function PendingActivation() {

    const location = useLocation();
    const pageLc = location.pathname.split('/')[1];

    const [listOfType, setListOfType] = useState('Employee');

    useEffect( ()=> {
        const org_type = localStorage.getItem(LOCAL_STORAGE_KEYS.active_org_type);
        if (org_type+'' === ORG_TYPE.SCHOOL+'') {
            setListOfType('Student');
        }
    }, [] )

    return (
        <React.Fragment>
            <Helmet title={`DQ-PRO | ${GET_APP_LOCALIZE_TEXT(pageLc, "navigation__pending_activations")}`} />
            <Typography variant="h3" gutterBottom display="inline">
                {/*{listOfType} Pending Activation*/}
                {GET_APP_LOCALIZE_TEXT(pageLc, "navigation__pending_activations")}
            </Typography>

            <Divider my={6} />

            <Grid container spacing={6} style={{ maxWidth: '100%', overflow: 'hidden' }}>
                <ResponsiveGridItem item xs={12}>
                    <ListProfilesActivations />
                </ResponsiveGridItem>
            </Grid>
        </React.Fragment>
    );
}

export default PendingActivation;
